export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "LocationMasterImportWorker.b2f3866373a7988e5b4b.worker.js");
}
